import {_, React, observer, observable, computed, action, useLocalStore, classNames, Iframe, useAsObservableSource, useRef, useEffect, autorun, runInAction} from '@api'
import {TabNode} from '@flexlayout'
import {IFlexLayoutTabProps} from '@stores'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {IFlexLayoutIFrameTabConfig} from '@stores/catalog/flexLayout'
import * as css from './BuyingBoardFlexLayoutTab.css'
import Postmate from 'postmate'
export const BuyingBoardUrl = {
  retail: 'http://usa-retail-salesboard-demo.centricsoftware.com/',
  wholesale: 'http://usa-wholesale-salesboard-demo.centricsoftware.com/',
  localhost: 'http://localhost:4000/login'
}

/// region Store

import overrideCss from '!!raw-loader!./BuyingBoardOverrides.css'

export class BuyingBoardFlexLayoutTabStore extends VipLocalStore {
  constructor(s, public props: Partial<MyProps>) {
    super(s)
    this.tab.iframe = this
  }

  @observable.ref ref: HTMLDivElement

  postmate: Postmate.ParentAPI

  registerEffects = () => {
    const toDispose = [
      autorun(async() => {
        const {ref, url, props: {flexNode: {id}}} = this
        if (this.ref) {
          console.log(`Updating postmate`)

          await runInAction(async () => {
              this.postmate?.destroy()

            ref.innerHTML = ''
            // Postmate.debug = true
            this.postmate = await new Postmate({
              container: ref, // Element to inject frame into
              url: url, // Page to load, must have postmate.js. This will also be the origin used for communication.
              name: id, // Set Iframe name attribute. Useful to get `window.name` in the child.
              classListArray: [css.iframe] //Classes to add to the iframe via classList, useful for styling.
            })

            const {postmate} = this
            postmate.call('injectCss', overrideCss)

            postmate.on('test', (msg) => {
              console.log(`Received message from child iframe - ${msg}`)
            })
          })
        }
      })
    ]

    return () => {
      this.postmate?.destroy()
      toDispose.forEach(d => d())
    }
  }

  @computed get tab() { return this.props.flexNode as TabNode }

  @computed get config() { return this.tab.config as IFlexLayoutIFrameTabConfig}
  @computed get url() {
    return this.config.settings.url ?? `https://www.google.com/webhp?igu=1`

    // return `http://cvip-BuyingBoard.centricsoftware.com/WebAccess/login.html`
    // return `http://cvip-BuyingBoard.centricsoftware.com/WebAccess/home.html#URL=C187840&RURL=&Tab=Target`
  }
}

export const BuyingBoardFlexLayoutTabStoreContext = React.createContext<BuyingBoardFlexLayoutTabStore>(null)
export const useBuyingBoardFlexLayoutTabStore = () => React.useContext(BuyingBoardFlexLayoutTabStoreContext)

/// endregion

/// region Components

interface MyProps extends IFlexLayoutTabProps {
  className?: string
}

export const BuyingBoardFlexLayoutTab = observer<MyProps>(function BuyingBoardFlexLayoutTab({className, flexNode, ...props}) {
  const obsProps = useAsObservableSource({flexNode}),
    store = useVipLocalStore((s) => new BuyingBoardFlexLayoutTabStore(s, obsProps)),
    ref = useRef<HTMLDivElement>(null),
    {registerEffects} = store

  useEffect(() => {
    store.ref = ref.current
  }, [ref.current])

  useEffect(() => registerEffects(), [])

  // console.log(props)

  return (
    <BuyingBoardFlexLayoutTabStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)} key={store.url} ref={ref}>
        {/*<IFrameWithTitleBar url={url} id={flexNode.id} hideTitlebar/>*/}
      </div>
    </BuyingBoardFlexLayoutTabStoreContext.Provider>)
})


/// endregion

const IFrameWithTitleBar = observer<{id: string, url: string, hideTitlebar?: boolean, className?: string}>(function IFrameWithTitleBar({id, url, hideTitlebar, className,...props}) {
    const store = useBuyingBoardFlexLayoutTabStore()

    return (<div {...props} data-hide-titlebar={hideTitlebar === true} className={classNames(className, css.frameWithTitleBar)}>
      <div className={css.titlebar}>
        <a href={url} target='_blank'>{url}</a>
      </div>
      <iframe src={url} className={css.iframe}
              id={id}
              scrolling='auto'
              sandbox='allow-scripts allow-same-origin allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-presentation allow-top-navigation '/>
    </div>)
})


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/content-panels/BuyingBoardFlexLayoutTab.tsx